<template>
  <div style="background-color: #e5e5e5">
    <v-layout class="bg">
      <CustomerAddSalesOrder v-if="hasRole(AdminUserPermissions.CUSTOMER_SALES_ORDER_ADD)" :customer_id="customer_id" :customer="customer" :subscribedPackages="subscribedPackages" />
    </v-layout>
    <v-layout justify-end>
      <v-checkbox label="Show Payment Pending " @change="onStatusChange" v-model="includePaymentPending"></v-checkbox>
    </v-layout>
    <v-data-table :mobile-breakpoint="0" class="row-pointer" :headers="headers" :items="salesOrderInfo" :items-per-page="10" :loading="loading">
      <template v-slot:item.dateTime="{ item }">
        {{ getDate(new Date(parseInt(item.created_At))) | moment("MMM DD YYYY hh:mm") }}
      </template>
      <template v-slot:item.order_number="{ item }">
        <v-row>
          <router-link
            :to="{
              name: 'CustomerDetails',
              params: { customerId: customer_id, packageId: item._id },
              query: { customerId: customer_id, packageId: item._id },
            }"
            class="mx-auto"
          >
            {{ item.order_number }}
          </router-link>
          <img class="ml-2" v-if="item.paymentMode == 'DEEMA'" src="@/assets/payment/deema.png" width="30" />
          <img class="ml-2" v-if="item.paymentMode == 'KNET'" src="@/assets/payment/knet.png" width="30" />
          <img class="ml-2" v-if="item.paymentMode == 'CARD'" src="@/assets/payment/card.png" width="30" />
          <img class="ml-2" v-if="item.paymentMode == 'INVOICE'" src="@/assets/payment/invoice.png" width="30" />
          <img class="ml-2" v-if="item.paymentMode == 'APPLE'" src="@/assets/payment/apple.png" width="30" />
        </v-row>
      </template>
      <template v-slot:item.start_date="{ item }">
        {{ getDate(new Date(parseInt(item.start_date))) | moment("MMM DD YYYY") }}
      </template>
      <template v-slot:item.end_date="{ item }">
        {{ getDate(new Date(parseInt(item.end_date))) | moment("MMM DD YYYY") }}
      </template>
      <template v-slot:item.planStatus="{ item }">
        <span
          :class="
            currentPlanStatus(item) == 'Active'
              ? 'green--text'
              : currentPlanStatus(item) == 'Payment Pending'
              ? 'orange--text'
              : currentPlanStatus(item) == 'Upcoming'
              ? 'blue--text'
              : currentPlanStatus(item) == 'Expired'
              ? 'red--text'
              : ''
          "
        >
          {{ currentPlanStatus(item) }}</span
        >
      </template>
      <template v-slot:item.currentStatus="{ item }">
        <span v-if="item.currentStatus == 'FREEZED'">
          <span v-if="isCurrentlyFrozen">
            Freezed
          </span>
          <span v-else>
            {{ currentPlanStatus(item) }}
          </span>
        </span>
        <span v-else>
          {{ item.currentStatus }}
        </span>
      </template>
      <template v-slot:item.packagePrice="{ item }">
        <span v-if="item.package_price">
          {{ numberWithCommas(item.package_price) }}
        </span></template
      >

      <template v-slot:item.discount="{ item }">{{ numberWithCommas(item.discount + item.promoCodeDiscount + item.walletApplied) }}</template>

      <template v-slot:item.total="{ item }">
        <PriceSplitup :subscribedPackage="item" />
      </template>
      <template v-slot:item.variant="{ item }">
        <span v-if="item.selected_variant && item.selected_variant.variantNameEn">
          {{ item.selected_variant.variantNameEn }}
        </span>
        <span v-else>-</span>
      </template>
      <template v-slot:item.day="{ item }">
        <v-row>
          <v-col cols="1" class="mt-4">
            {{ item.package.availableChoices[0].availableNumOfDays }}
          </v-col>
          <v-col cols="1"> <AdditionalMeals :additionalMeals="item.additionalMeals" /> </v-col>
        </v-row>
      </template>
      <template v-slot:item.createdBy="{ item }">
        <span v-if="item.createdBy">
          {{ capitalizeFirstLetter(item.createdBy.firstnameEn) }}
          {{ capitalizeFirstLetter(item.createdBy.lastnameEn) }}
        </span>
      </template>

      <template v-slot:item.actions="{ item }">
        <!-- {{ indexOf(props.item._id) }} -->
        <v-row>
          <v-col cols="1">
            <div v-if="isPaymentPanding(item)">
              <RegenerateSalesOrderPayment v-if="hasRole(AdminUserPermissions.CUSTOMER_SALES_ORDER_UPDATE)" :salesOrder="item" />
            </div>
          </v-col>
          <v-col cols="1">
            <div v-if="isEditEnabled(item)">
              <CustomerSalesorderUpdate v-if="hasRole(AdminUserPermissions.CUSTOMER_SALES_ORDER_UPDATE)" :salesOrderInfo="item" :customer_id="customer_id" :allPackages="salesOrderInfo" />
            </div>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import CustomerAddSalesOrder from "../salesOrder/CustomerAddSalesOrder.vue";
import RegenerateSalesOrderPayment from "../salesOrder/RegenerateSalesOrderPayment.vue";
import AdditionalMeals from "../../../reports/components/AdditionalMeals.vue";
import CustomerSalesorderUpdate from "../salesOrder/CustomerSalesorderUpdate.vue";
import PriceSplitup from "../salesOrder/PriceSplitup.vue";

import moment from "moment";
import { tz } from "moment-timezone";
import { TIME_ZONE, Utils } from "../../../utils/utils";
export default {
  components: {
    CustomerAddSalesOrder,
    PriceSplitup,
    CustomerSalesorderUpdate,
    RegenerateSalesOrderPayment,
    AdditionalMeals,
  },
  props: {
    customer_id: {
      required: true,
    },
    customer: {
      required: true,
    },
    loading: {
      required: true,
    },
    salesOrder: {
      required: true,
    },
  },

  watch: {
    salesOrder: {
      handler() {
        this.subscribedPackages = this.salesOrder;
        this.runningPackages = Utils.getActiveAndPendingCustomerPackages(this.salesOrder);
        this.salesOrderInfo = JSON.parse(JSON.stringify(this.salesOrder));
        this.salesOrderInfo = this.salesOrderInfo.sort(function(a, b) {
          return b.order_number - a.order_number;
        });

        if (!this.includePaymentPending) {
          this.salesOrderInfo = this.salesOrderInfo.filter(x => x.payment_status == "SUCCESS");
        }
      },
      deep: true,
    },
  },

  data() {
    return {
      tz: tz,
      runningPackages: [],
      includePaymentPending: false,
      headers: [
        {
          text: "Order Number",
          value: "order_number",
          width: 70,
          sortable: false,
        },
        { text: "Date, Time", value: "dateTime", width: 170, sortable: false },
        {
          text: "Start Date",
          value: "start_date",
          width: 120,
          sortable: false,
        },
        { text: "End Date", value: "end_date", width: 120, sortable: false },
        { text: "Plan", value: "package.titleEn", width: 140, sortable: false },
        { text: "Variant", value: "variant", width: 120, sortable: false },
        {
          text: "Day",
          value: "day",
          width: 120,
          sortable: false,
        },
        {
          text: "Plan Status",
          value: "planStatus",
          width: 100,
          sortable: false,
        },
        {
          text: "Current Status",
          value: "currentStatus",
          width: 120,
          sortable: false,
        },
        {
          text: "Price",
          value: "packagePrice",
          width: 90,
          sortable: false,
        },
        { text: "Discount", value: "discount", width: 90, sortable: false },

        { text: "Net Price", value: "total", width: 90, sortable: false },
        { text: "Paid By", value: "paid_by", width: 90, sortable: false },
        { text: "Created By", value: "createdBy", width: 120, sortable: false },
        {
          text: "Action",
          value: "actions",
          sortable: false,
          width: 80,
        },
      ],
      salesOrderInfo: [],
      subscribedPackages: [],
      freezeDays: [],
    };
  },
  computed: {
    isCurrentlyFrozen() {
      if (this.freezeDays && this.freezeDays.length > 0) {
        return this.freezeDays.some((f) => f.isActive);
      }
      return false;
    },
  },
  created() {
    this.getCustomerFreezeDays();
    this.subscribedPackages = this.salesOrder;
    this.salesOrderInfo = JSON.parse(JSON.stringify(this.salesOrder));
    this.salesOrderInfo = this.salesOrderInfo.sort(function(a, b) {
      return b.order_number - a.order_number;
    });

    this.runningPackages = Utils.getActiveAndPendingCustomerPackages(this.salesOrder);

    if (!this.includePaymentPending) {
      this.salesOrderInfo = this.salesOrderInfo.filter(x => x.payment_status == "SUCCESS");
    }
  },
  methods: {
    onStatusChange() {
      this.salesOrderInfo = JSON.parse(JSON.stringify(this.salesOrder));
      this.salesOrderInfo = this.salesOrderInfo.sort(function(a, b) {
        return b.order_number - a.order_number;
      });
      if (!this.includePaymentPending) {
        this.salesOrderInfo = this.salesOrderInfo.filter(x => x.payment_status == "SUCCESS");
      }
    },

    isEditEnabled(order) {
      let planStatus = this.currentPlanStatus(order);
      if (planStatus == "Active" || planStatus == "Upcoming") {
        return true;
      }
      return false;
    },
    isDeleteEnabled(order) {
      let planStatus = this.currentPlanStatus(order);
      if (planStatus == "Active" || planStatus == "Upcoming") {
        return true;
      }
      return false;
    },
    isPaymentPanding(order) {
      let lastPackage = this.subscribedPackages[this.subscribedPackages.length - 1];
      let planStatus = this.currentPlanStatus(order);
      if (planStatus == "Payment Pending") {
        if (lastPackage._id == order._id) {
          return true;
        }
      }
      return false;
    },
    handleClick(item) {
      console.log(item);
      this.$router.push({
        name: "CustomerDetails",
        query: { customerId: this.customer_id, packageId: item._id },
      });
    },

    getDate(date) {
      let converted = moment(date).tz(TIME_ZONE);
      return converted;
    },

    itemRowBackground: function(item) {
      if ((this.currentPlanStatus(item) == "Payment Pending") | (this.currentPlanStatus(item) == "PENDING")) {
        return "dark--text";
      } else if (this.currentPlanStatus(item) == "Active") {
        return "green--text";
      } else return "blue--text";
    },
    currentPlanStatus(order) {
      // console.log(order.payment_status);

      var packageStatus = "Expired";
      if (order.payment_status === "PENDING") {
        packageStatus = "Payment Pending";
      } else {
        if (this.runningPackages.activePackage) {
          if (order._id == this.runningPackages.activePackage._id) {
            packageStatus = "Active";
          }
        }
        if (this.runningPackages.upcomingPackage) {
          if (order._id == this.runningPackages.upcomingPackage._id) {
            packageStatus = "Upcoming";
          }
        }
      }
      // console.log(packageStatus);
      return packageStatus;
    },
    getCustomerFreezeDays() {
      this.$apollo
        .query({
          query: require("../freeze/api/getCustomerFreezeDays.graphql"),
          variables: {
            customer: this.customer_id,
          },
          fetchPolicy: "network-only",
        })
        .then((data) => {
          this.freezeDays = data.data.getCustomerFreezeDays;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  mounted() {
    this.$root.$on("getCustomerFreezeDays", () => {
      this.getCustomerFreezeDays();
    });
  },
};
</script>
<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
